// Tab switcher for the admin /hubspot/tools page (Backfill / Seed / Sync / Users / Organizations / Subscriptions).
import { ApplicationController } from "../../support/application-controller";

export default class extends ApplicationController {
    static targets = [
        "content",
        "backfillTab",
        "seedTab",
        "syncTab",
        "usersTab",
        "organizationsTab",
        "subscriptionsTab",
        "backfillPane",
        "seedPane",
        "syncPane",
        "usersPane",
        "organizationsPane",
        "subscriptionsPane"
    ];

    toggle(event) {
        if (event) event.preventDefault();
        if (this.hasContentTarget) {
            var isHidden = this.contentTarget.style.display === "none";
            this.contentTarget.style.display = isHidden ? "block" : "none";

            var icon = this.element.querySelector(".hubspot-tools-panel__toggle-icon .material-icons");
            if (icon) {
                icon.textContent = isHidden ? "expand_less" : "expand_more";
            }
        }
    }

    showBackfill(event) { if (event) event.preventDefault(); this.activateTab("backfill"); }
    showSeed(event) { if (event) event.preventDefault(); this.activateTab("seed"); }
    showSync(event) { if (event) event.preventDefault(); this.activateTab("sync"); }
    showUsers(event) { if (event) event.preventDefault(); this.activateTab("users"); }
    showOrganizations(event) { if (event) event.preventDefault(); this.activateTab("organizations"); }
    showSubscriptions(event) { if (event) event.preventDefault(); this.activateTab("subscriptions"); }

    activateTab(tabName) {
        var tabs = [
            { name: "backfill", tab: "backfillTabTarget", pane: "backfillPaneTarget", hasTab: "hasBackfillTabTarget", hasPane: "hasBackfillPaneTarget" },
            { name: "seed", tab: "seedTabTarget", pane: "seedPaneTarget", hasTab: "hasSeedTabTarget", hasPane: "hasSeedPaneTarget" },
            { name: "sync", tab: "syncTabTarget", pane: "syncPaneTarget", hasTab: "hasSyncTabTarget", hasPane: "hasSyncPaneTarget" },
            { name: "users", tab: "usersTabTarget", pane: "usersPaneTarget", hasTab: "hasUsersTabTarget", hasPane: "hasUsersPaneTarget" },
            { name: "organizations", tab: "organizationsTabTarget", pane: "organizationsPaneTarget", hasTab: "hasOrganizationsTabTarget", hasPane: "hasOrganizationsPaneTarget" },
            { name: "subscriptions", tab: "subscriptionsTabTarget", pane: "subscriptionsPaneTarget", hasTab: "hasSubscriptionsTabTarget", hasPane: "hasSubscriptionsPaneTarget" }
        ];

        var self = this;
        tabs.forEach(function(t) {
            if (self[t.hasTab]) {
                var activeClass = self[t.tab].className.indexOf("hubspot-tools-page__tab") >= 0
                    ? "hubspot-tools-page__tab--active"
                    : "hubspot-tools-panel__tab--active";
                self[t.tab].classList.toggle(activeClass, t.name === tabName);
            }
            if (self[t.hasPane]) {
                self[t.pane].style.display = t.name === tabName ? "block" : "none";
            }
        });

        // Broadcast an event so tab panes can lazy-load data the first time they're shown.
        var ev = new CustomEvent("hubspot-tools:tab-activated", { detail: { tab: tabName } });
        this.element.dispatchEvent(ev);
    }
}
